export const settings = {
	dots: true,
	infinite: false,
	speed: 500,
	slidesToShow: 1,
	slidesToScroll: 1,
	initialSlide: 0,
	responsive: [
		{
			breakpoint: 1024,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: true,
				dots: true
			}
		},
		{
			breakpoint: 600,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				initialSlide: 2,
			}
		},
		{
			breakpoint: 480,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1
			}
		}
	],
	appendDots: (dots) => (
		<div
			style={{
				display: "flex",
				justifyContent: "flex-end",
				backgroundColor: "rgba(0, 0, 0, 0.6)",
				padding: "10px",
				marginBottom: "2rem",
			}}
		>
			<ul style={{ margin: "0px", color: "white" }}> {dots} </ul>
		</div>
	),
};
